import React, { useMemo, useState, useContext } from "react";
import { useEffect } from "react";
import { AuthContext } from "../../shared/context/auth-context";

import { useHistory } from "react-router-dom";
import { v4 as uuid } from "uuid";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useForm } from "../../shared/hooks/form-hook";
import DatePicker from "react-datepicker";
import { useHttpClient } from "../../shared/hooks/http-hook";
import Button from "../../shared/components/formElements/Button";
import {
  VALIDATOR_NOT_REQUIRE,
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE,
  VALIDATOR_MAXLENGTH,
  VALIDATOR_SPECIAL_CHARACHTER,
  VALIDATOR_NUMERIC
} from "../../shared/util/validators";
import "react-datepicker/dist/react-datepicker.css";
import Input from "../../shared/components/formElements/Input";
import CustomerOrderList from "../../order/components/CustomerOrderList";
import "./NewSpecialOrder.css";
import { momentDate } from "../../order/pages/NewOrder";
import Capitalize from "../../shared/components/UIElements/Capitalize ";


const NewSpecialOrder = () => {
  const auth = useContext(AuthContext);
  const orderNumber = useMemo(() => uuid().slice(0, 8), []);
  const [loadedCustomers, setLoadedCustomers] = useState([]);

  const [activateButton, setActivateButton] = useState(false);
  const [startDate, setStartDate] = useState(new Date(momentDate()));
  const [eventDate, setEventDate] = useState();
  const [arrivalDate, setArrivalDate] = useState();
  const history = useHistory();

  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
    {
      orderNumber: {
        value: orderNumber,
        isValid: true,
      },
      style: {
        value: "",
        isValid: true,
      },
      company: {
        value: "",
        isValid: true,
      },
      color: {
        value: "",
        isValid: true,
      },
      USSize: {
        value: "",
        isValid: true,
      },
      customer: {
        value: "",
        isValid: true,
      },
      startDate: {
        value: startDate,
        isValid: true,
      },
      eventDate: {
        value: eventDate,
        isValid: true,
      },
      arrivalDate: {
        value: arrivalDate,
        isValid: true,
      },
      location: {
        value: "",
        isValid: true,
      },
      archive: {
        value: false,
        isValid: true,
      },
      cost: {
        value: "",
        isValid: true,
      },
      price: {
        value: "",
        isValid: true,
      },
    },
    false
  );

  useEffect(() => {
    formState.inputs.startDate.value = startDate;
    formState.inputs.eventDate.value = eventDate;
    formState.inputs.arrivalDate.value = arrivalDate;
  }, [
    startDate,
    eventDate,
    arrivalDate,
    formState.inputs.startDate,
    formState.inputs.eventDate,
    formState.inputs.arrivalDate,
  ]);

  const enableButton = (style, USSize, location, eventDate, arrivalDate, cost, price) => {
    if (
      style &&
      USSize &&
      location &&
      eventDate.value &&
      arrivalDate.value &&
      cost && price
    ) {
      setActivateButton(true);
    } else {
      setActivateButton(false);
    }  
  }

  useEffect(() => {
    enableButton(
      formState.inputs.style.value,
      formState.inputs.USSize.value,
      formState.inputs.location.value,
      formState.inputs.eventDate,
      formState.inputs.arrivalDate,
      formState.inputs.cost.value,
      formState.inputs.price.value,
    );
  }, [
    startDate,
    eventDate,
    arrivalDate,
    formState.inputs.style.value,
    formState.inputs.USSize.value,
    formState.inputs.location.value,
    formState.inputs.eventDate,
    formState.inputs.arrivalDate,
    formState.inputs.cost.value,
    formState.inputs.price.value,
  ]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const responseCustomerData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "/customers",
          "GET",
          null,
          { Authorization: "Bearer " + auth.token }
        );
        setLoadedCustomers(responseCustomerData.customers);
      } catch (err) {}
    };
    fetchCustomers();
  }, [sendRequest, auth.token]);

  const specialOrderSubmitHandler = async (event) => {
    
    event.preventDefault();
    if (
      formState.inputs.style.value &&
      formState.inputs.USSize.value &&
      formState.inputs.location.value &&
      formState.inputs.cost.value &&
      formState.inputs.price.value
    ) {
     
      try {
        await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "/specialOrders/new",
          "POST",
          JSON.stringify({
            orderNumber: formState.inputs.orderNumber.value,
            style: Capitalize(formState.inputs.style.value)+
            "_" + Capitalize(formState.inputs.color.value) +
            "_" + Capitalize(formState.inputs.USSize.value),
            company: Capitalize(formState.inputs.company.value),
            color: Capitalize(formState.inputs.color.value),
            USSize: Capitalize(formState.inputs.USSize.value),
            customer: formState.inputs.customer.value,
            startDate: formState.inputs.startDate.value,
            eventDate: formState.inputs.eventDate.value,
            arrivalDate: formState.inputs.arrivalDate.value,
            location: Capitalize(formState.inputs.location.value),
            archive: formState.inputs.archive.value,
            description: formState.inputs.description.value,
            cost: formState.inputs.cost.value,
            price: formState.inputs.price.value,
          }),
          {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          }
        );
       
        history.push("/specialOrders");
      } catch (err) {}
    }
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <form className="special-order-form" onSubmit={specialOrderSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h2 style={{ textAlign: "center" }}>Create New Special Order</h2>

        <div className="flex justify-around">
          <div className="w-25  mr2">
            <code>
              <label className="f6 b db mb2">Order Number</label>
              <input
                className="input-reset ba b--black-20  mb2 db w-100 h"
                type="text"
                value={orderNumber}
                readOnly={true}
              />
            </code>
          </div>
          <div className="w-25  mr2">
            <code>
              <label className="f6 b db mb2">Order Date</label>
              <DatePicker
                className="order-date"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </code>
          </div>
          <div className="w-25  mr2">
            <code>
              <label className="f6 b db mb2"><span style={{color:"red"}}>*&nbsp;</span>Arrival Date</label>
              <DatePicker
                className="order-date"
                selected={arrivalDate}
                onChange={(arrivalDate) => setArrivalDate(arrivalDate)}
              />
            </code>
          </div>
          <div className=" w-25  mr2">
            <code>
              <label className="f6 b db mb2"><span style={{color:"red"}}>*&nbsp;</span>Event Date</label>
              <DatePicker
                className="order-date"
                selected={eventDate}
                onChange={(eventDate) => setEventDate(eventDate)}
              />
            </code>
          </div>
        </div>
        <div className="flex justify-around">
          <div className=" w-100  mr2">
            <CustomerOrderList
              id="customer"
              label="Customer"
              onInput={inputHandler}
              type="text"
              suggestionArray={loadedCustomers}
            />
          </div>
        </div>
        <div className="flex justify-around">
          <div className=" w-33  mr2">
            <Input
              id="style"
              element="input"
              type="text"
              label="Style"
              red= "red"
              validators={[
                VALIDATOR_REQUIRE(),
                VALIDATOR_MAXLENGTH(23),
                VALIDATOR_SPECIAL_CHARACHTER(),
              ]}
              errorText="Please enter a valid style."
              onInput={inputHandler}
            />
          </div>
          <div className=" w-33  mr2">
            <Input
              id="company"
              element="input"
              type="text"
              label="Company"
              validators={[
                VALIDATOR_NOT_REQUIRE(),
                VALIDATOR_MAXLENGTH(23),
                VALIDATOR_SPECIAL_CHARACHTER(),
              ]}
              errorText="Please enter a valid company."
              onInput={inputHandler}
            />
          </div>
          <div className=" w-33  mr2">
            <Input
              id="location"
              element="input"
              type="text"
              label="Location"
              red= "red"
              validators={[
                VALIDATOR_REQUIRE(),
                VALIDATOR_MINLENGTH(1),
                VALIDATOR_MAXLENGTH(23),
                VALIDATOR_SPECIAL_CHARACHTER(),
              ]}
              errorText="Please enter a valid location."
              onInput={inputHandler}
            />
          </div>
        </div>
        <div className="flex justify-around">
          <div className=" w-25  mr2">
            <Input
              placeholder="$0.00"
              id="cost"
              element="input"
              type="number"
              label="Cost"
              red= "red"
              validators={[
                VALIDATOR_REQUIRE(),
                VALIDATOR_SPECIAL_CHARACHTER(),
                VALIDATOR_NUMERIC()
              ]}
              errorText="Please enter a valid number."
              onInput={inputHandler}
            />
          </div>
          <div className=" w-25 mr2">
            <Input
            placeholder="$0.00"
              id="price"
              element="input"
              type="number"
              label="Price"
              red= "red"
              validators={[
                VALIDATOR_REQUIRE(),
                VALIDATOR_SPECIAL_CHARACHTER(),
                VALIDATOR_NUMERIC()
              ]}
              errorText="Please enter a valid number."
              onInput={inputHandler}
            />
          </div>
          <div className=" w-25 mr2">
            <Input
              id="color"
              element="input"
              type="text"
              label="Color"
              validators={[
                VALIDATOR_NOT_REQUIRE(),
                VALIDATOR_MAXLENGTH(20),
                VALIDATOR_SPECIAL_CHARACHTER(),
              ]}
              errorText="Please enter a valid color."
              onInput={inputHandler}
            />
          </div>
          <div className=" w-25  mr2">
            <Input
              id="USSize"
              element="input"
              type="text"
              label="US Size"
              red= "red"
              validators={[
                VALIDATOR_NOT_REQUIRE(),
                VALIDATOR_MAXLENGTH(20),
                VALIDATOR_SPECIAL_CHARACHTER(),
              ]} 
              errorText="Please enter a valid US size."
              onInput={inputHandler}
            />
          </div>
        </div>

        <div className="flex justify-around">
          <div className=" w-100 ">
            <Input
              id="description"
              label="Description"
              validators={[VALIDATOR_MINLENGTH(0), VALIDATOR_NOT_REQUIRE()]}
              onInput={inputHandler}
            />
          </div>
        </div>
        <Button type="submit" disabled={!activateButton}>
          ADD ORDER
        </Button>
        <Button inverse to="/specialOrders">
          CANCEL
        </Button>
      </form>
    </React.Fragment>
  );
};

export default NewSpecialOrder;
